export const messages = {
  en: {
    dict: {
      search: {
        title: 'Search Condition',
        name: 'name',
        description: 'description',
        createTime: 'createTime',
        tableName: 'tableName',
        tableColumns: 'tableColumns',
        placeholder: 'Please enter dict name'
      },
      list: {
        title: 'dict List'
      },
      dialog: {
        addTitle: 'Add Dict',
        editTitle: 'Edit Dict',
        delTitle: 'Delete Dict',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        name: 'name',
        description: 'description',
        createTime: 'createTime',
        tableName: 'tableName',
        tableColumns: 'tableColumns',
        statusCd: 'statusCd',
      },
      table: {
        name: 'name',
        description: 'description',
        createTime: 'createTime',
        tableName: 'tableName',
        tableColumns: 'tableColumns',
        statusCd: 'statusCd',
      },
      validate: {
        name: 'Please enter name',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add Dict success'
      },
      edit: {
        success: 'Edit Dict success'
      },
      delete: {
        success: 'Delete Dict success',
        confirm: 'Are you sure to delete this dict?'
      },
      fetchError: 'Failed to fetch dict list'
    }
  },
  zh: {
    dict: {
      search: {
        title: '查询条件',
        name: '名称',
        description: '描述',
        createTime: '创建时间',
        tableName: '表名',
        tableColumns: '表字段',
        placeholder: '请输入字典名称'
      },
      list: {
        title: '字典列表'
      },
      dialog: {
        addTitle: '添加字典',
        editTitle: '编辑字典',
        delTitle: '删除字典',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        name: '名称',
        description: '描述',
        createTime: '创建时间',
        tableName: '表名',
        tableColumns: '表字段',
        statusCd: '值',
      },
      table: {
        name: '名称',
        description: '描述',
        createTime: '创建时间',
        tableName: '表名',
        tableColumns: '表字段',
        statusCd: '值',

      },
      validate: {
        name: '请输入名称',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加字典成功'
      },
      edit: {
        success: '编辑字典成功'
      },
      delete: {
        success: '删除字典成功',
        confirm: '确认删除该字典吗？'
      },
      fetchError: '获取字典列表失败'
    }
  }
}